<template>
  <LabelledInput
    label="Select panel"
    helpful-tip="Each panel can have different formatting"
  >
    <b-select
      v-model="panel"
      :disabled="imageUploading"
      data-cy="panel-picker"
    >
      <option :value="SIDEBAR_TOP">
        Sidebar Top
      </option>
      <option :value="SIDEBAR_BOT">
        Sidebar Bottom
      </option>
      <option :value="ABOVE_BUBBLES">
        Above Bubbles
      </option>
      <option :value="ABOVE_MAP">
        Above Map
      </option>
      <option
        v-if="splashScreen"
        :value="SPLASH_SCREEN"
      >
        Splash screen
      </option>
      <option
        v-if="faq"
        :value="INFO_FAQ"
      >
        Info Panel
      </option>
    </b-select>
  </LabelledInput>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import { StoryKeys, NodeStoryKeys } from '@/types'
import {
  VIEW_MAP,
  VIEW_PROJECTS,
} from '@/constants'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

const components = {
  LabelledInput,
}
const props = {
  faq: Boolean,
  splashScreen: Boolean,
}

// eslint-disable-next-line no-use-before-define
@Component<PanelPicker>({
  components,
  watch: {
    panel (newPanel, oldPanel) {
      let mainpanel = null
      if (newPanel === StoryKeys.ABOVE_MAP) {
        mainpanel = VIEW_MAP
      } else if (newPanel === StoryKeys.ABOVE_BUBBLES || oldPanel === StoryKeys.ABOVE_MAP) {
        mainpanel = VIEW_PROJECTS
      }
      if (mainpanel) {
        this.$router.push({ params: { mainpanel } })
      }
    },
  },
})
export default class PanelPicker extends Vue.extend({ props }) {
  INFO_FAQ = StoryKeys.INFO_FAQ
  SPLASH_SCREEN = StoryKeys.SPLASH_SCREEN
  ABOVE_BUBBLES = StoryKeys.ABOVE_BUBBLES
  ABOVE_MAP = StoryKeys.ABOVE_MAP
  SIDEBAR_TOP = StoryKeys.SIDEBAR_TOP
  SIDEBAR_BOT = StoryKeys.SIDEBAR_BOT

  get panel () {
    return this.$typedStore.public.display.storyBuilderPanel as NodeStoryKeys
  }

  set panel (newPanel) {
    this.$typedStore.public.display.updateStoryBuilderPanel(newPanel)
  }

  get imageUploading () {
    return this.$typedStore.primary.entities.images.imageUploading
  }
}
</script>
